export const useValidatedChangeWithError =
  (setFormData, setErrors) =>
  (field, validator) =>
  (e) => {
    const raw = e.target.value;
    const { value, error } = validator(raw);

    // エラー更新
    setErrors((prev) => ({
      ...prev,
      [field]: error,
    }));

    if (value === null) return;

    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
